// @flow
import React from 'react';
import classNames from 'classnames';
import { Button } from '@elements';
import { PlanFeatures, PlanPrice, PopularBadge } from './PlanParts';

type Props = {
  type: string,
  plan: Object,
  onSubscribe: Function,
  isOpening: boolean,
  disabled: boolean,
  _: Function,
};

// Tablet and desktop: one card per plan, side by side.
const PlanCard = ({ type, plan, onSubscribe, isOpening, disabled, _ }: Props) => (
  <article className={classNames('planCard', { recommended: plan.recommended })}>
    <header className="planCardHead">
      <h2>{plan.name}</h2>
      {plan.recommended && <PopularBadge _={_} />}
    </header>
    <p className="planTagline">{_(`label/tagline/${type}`)}</p>
    <PlanPrice plan={plan} _={_} />
    <Button
      className={classNames('choosePlan', { primary: plan.recommended })}
      text={_('action/choose_plan')}
      isLoading={isOpening}
      disabled={disabled}
      loadingMessage={_('label/opening_checkout')}
      greenSpinner={!plan.recommended}
      onClick={() => onSubscribe(plan.plan)}
    />
    <PlanFeatures type={type} _={_} />
  </article>
);

export default PlanCard;
